export const isCognitoOAuthReturnUrl = (): boolean => {
  const u = new URL(window.location.href);
  return (
    (u.searchParams.has("code") && u.searchParams.has("state")) ||
    u.searchParams.has("error")
  );
};

export const stripCognitoOAuthCallbackFromUrl = (): void => {
  const u = new URL(window.location.href);
  u.searchParams.delete("code");
  u.searchParams.delete("state");
  u.searchParams.delete("error");
  u.searchParams.delete("error_description");
  const search = u.searchParams.toString();
  const next = u.pathname + (search === "" ? "" : `?${search}`) + u.hash;
  window.history.replaceState({}, document.title, next);
};
